import { Action } from '@ngrx/store';
import {
  ManagerCompany,
  ManagerCompanyUser,
  CustomerManagerCompany,
  ManagerCustomerUser,
  ManagerJobLockStatus
} from '@model';

export enum ManagerCompaniesActionTypes {
  ManagerCompaniesLoadData = '[ManagerCompanies] Load data',
  ManagerCompaniesLoadSuccess = '[ManagerCompanies] Load success',
  ManagerCompaniesLoadFail = '[ManagerCompanies] Load fail',

  ManagerCompanySelect = '[ManagerCompany] Select',

  ManagerCompaniesUsersLoadData = '[ManagerCompaniesUsers] Load data',
  ManagerCompaniesUsersLoadSuccess = '[ManagerCompaniesUsers] Load success',
  ManagerCompaniesUsersLoadFail = '[ManagerCompaniesUsers] Load fail',

  ManagerCompanyUserSelect = '[ManagerCompanyUserSelect] Select',

  UpdateManagerCompanyUser = '[ManagerCompanyUser] Update',
  UpdateManagerCompanyUserSuccess = '[ManagerCompanyUser] Update success',
  UpdateManagerCompanyUserFail = '[ManagerCompanyUser] Update fail',

  ManagerCompanyRemove = '[ManagerCompany] Remove',
  ManagerCompanyRemoveSuccess = '[ManagerCompany] Remove success',
  ManagerCompanyRemoveFail = '[ManagerCompany] Remove fail',

  ManagerCompanyCustomersLoadData = '[ManagerCompanyCustomers] Load data',
  ManagerCompanyCustomersLoadSuccess = '[ManagerCompanyCustomers] Load success',
  ManagerCompanyCustomersLoadFail = '[ManagerCompanyCustomers] Load fail',

  ManagerCompanyUserCustomersLoadData = '[ManagerCompanyUserCustomers] Load data',
  ManagerCompanyUserCustomersLoadSuccess = '[ManagerCompanyUserCustomers] Load success',
  ManagerCompanyUserCustomersLoadFail = '[ManagerCompanUserCustomers] Load fail',

  IsManagerCompanyUserExclusiveAdministrator = '[ManagerCompanyUser] exclusive administrator',
  IsManagerCompanyUserExclusiveAdministratorSuccess = '[ManagerCompanyUser] exclusive administrator success',
  IsManagerCompanyUserExclusiveAdministratorFail = '[ManagerCompanyUser] exclusive administrator fail',

  IsManagerCompanyUserLockedForUpdate = '[ManagerCompanyUser] locked for update',
  IsManagerCompanyUserLockedForUpdateSuccess = '[ManagerCompanyUser] locked for update success',
  IsManagerCompanyUserLockedForUpdateFail = '[ManagerCompanyUser] locked for update fail',

  BulkUpdateManagerCompanyUser = '[ManagerCompanyUser] bulk update',
  BulkUpdateManagerCompanyUserSuccess = '[ManagerCompanyUser] bulk update success',
  BulkUpdateManagerCompanyUserFail = '[ManagerCompanyUser] bilk update fail',
  ClearBulkUpdateManagerCompanyUserState = '[ManagerCompanyUser] clear bulk update state',

  ManagerCompanyUsersLockedForUpdateLoadData = '[ManagerCompanyUsers] locked for update',
  ManagerCompanyUsersLockedForUpdateLoadSuccess = '[ManagerCompanyUsers] locked for update success',
  ManagerCompanyUsersLockedForUpdateLoadFail = '[ManagerCompanyUsers] locked for update fail',
  ClearManagerCompanyUsersLockedForUpdateState = '[ManagerCompanyUsers] clear locked for update state',

  ManagerUserLockUpdate = '[ManagerCompanyUsers] Locked managerusers',
 
  SetCustomerSelection = '[ManagerCompanyUser] Set Customer Selection',

  SetPrimaryContact = '[ManagerCustomerUser] Set primary contact',
  SetPrimaryContactSuccess = '[ManagerCustomerUser] Set primary contact success',
  SetPrimaryContactFail = '[ManagerCustomerUser] Set primary contact fail',

  ManagerCompanyTabChanged = '[ManagerCompany] Tab changed',

  LockManagerCompanyUserForDelete = '[ManagerCompanyUser] lock for delete',
  LockManagerCompanyUserForDeleteSuccess = '[ManagerCompanyUser] lock for delete success',
  LockManagerCompanyUserForDeleteFail = '[ManagerCompanyUser] lock for delete fail',
  ClearLockManagerCompanyUserForDeleteState = '[ManagerCompanyUser] clear lock for delete',
}

export class ManagerCompaniesLoadData implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompaniesLoadData;
  constructor() {}
}
export class ManagerCompaniesLoadSuccess implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompaniesLoadSuccess;
  constructor(public payload: ManagerCompany[]) {}
}
export class ManagerCompaniesLoadFail implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompaniesLoadFail;
  constructor(public payload: any) {}
}

export class ManagerCompanySelect implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanySelect;
  constructor(public payload: ManagerCompany) {}
}

export class ManagerCompaniesUsersLoadData implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompaniesUsersLoadData;
  constructor(public payload: number) {}
}

export class ManagerCompaniesUsersLoadSuccess implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompaniesUsersLoadSuccess;
  constructor(public payload: ManagerCompanyUser[]) {}
}

export class ManagerCompaniesUsersLoadFail implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompaniesUsersLoadFail;
  constructor(public payload: any) {}
}

export class ManagerCompanyUserSelect implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyUserSelect;
  constructor(public payload: ManagerCompanyUser) {}
}

export class BulkUpdateManagerCompanyUser implements Action {
  readonly type = ManagerCompaniesActionTypes.BulkUpdateManagerCompanyUser;
  constructor(public payload: ManagerCompanyUser) {}
}
export class BulkUpdateManagerCompanyUserSuccess implements Action {
  readonly type = ManagerCompaniesActionTypes.BulkUpdateManagerCompanyUserSuccess;
  constructor(public payload: ManagerJobLockStatus) {}
}
export class BulkUpdateManagerCompanyUserFail implements Action {
  readonly type = ManagerCompaniesActionTypes.BulkUpdateManagerCompanyUserFail;
  constructor(public payload: any) {}
}
export class ClearBulkUpdateManagerCompanyUserState implements Action {
  readonly type = ManagerCompaniesActionTypes.ClearBulkUpdateManagerCompanyUserState;
  constructor() {}
}

export class UpdateManagerCompanyUser implements Action {
  readonly type = ManagerCompaniesActionTypes.UpdateManagerCompanyUser;
  constructor(public payload: ManagerCompanyUser) {}
}
export class UpdateManagerCompanyUserSuccess implements Action {
  readonly type = ManagerCompaniesActionTypes.UpdateManagerCompanyUserSuccess;
  constructor(public payload: ManagerCompanyUser) {}
}
export class UpdateManagerCompanyUserFail implements Action {
  readonly type = ManagerCompaniesActionTypes.UpdateManagerCompanyUserFail;
  constructor(public payload: any) {}
}
export class IsManagerCompanyUserExclusiveAdministrator implements Action {
  readonly type = ManagerCompaniesActionTypes.IsManagerCompanyUserExclusiveAdministrator;
  constructor(public payload: ManagerCompanyUser) {}
}
export class IsManagerCompanyUserExclusiveAdministratorSuccess implements Action {
  readonly type = ManagerCompaniesActionTypes.IsManagerCompanyUserExclusiveAdministratorSuccess;
  constructor(public payload: boolean) {}
}
export class IsManagerCompanyUserExclusiveAdministratorFail implements Action {
  readonly type = ManagerCompaniesActionTypes.IsManagerCompanyUserExclusiveAdministratorFail;
  constructor(public payload: any) {}
}
export class ManagerCompanyRemove implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyRemove;
  constructor(public payload: ManagerCompany) {}
}
export class ManagerCompanyRemoveSuccess implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyRemoveSuccess;
  constructor(public payload: ManagerCompany) {}
}
export class ManagerCompanyRemoveFail implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyRemoveFail;
  constructor(public payload: any) {}
}
export class ManagerCompanyCustomersLoadData implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyCustomersLoadData;
  constructor(public payload: { managerCompanyId: number }) {}
}
export class ManagerCompanyCustomersLoadSuccess implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyCustomersLoadSuccess;
  constructor(public payload: CustomerManagerCompany[]) {}
}
export class ManagerCompanyCustomersLoadFail implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyCustomersLoadFail;
  constructor(public payload: any) {}
}
export class ManagerCompanyUserCustomersLoadData implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyUserCustomersLoadData;
  constructor(public payload: { managerCompanyId: number; userId: string }) {}
}
export class ManagerCompanyUserCustomersLoadSuccess implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyUserCustomersLoadSuccess;
  constructor(public payload: ManagerCustomerUser[]) {}
}
export class ManagerCompanyUserCustomersLoadFail implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyUserCustomersLoadFail;
  constructor(public payload: any) {}
}
export class IsManagerCompanyUserLockedForUpdate implements Action {
  readonly type = ManagerCompaniesActionTypes.IsManagerCompanyUserLockedForUpdate;
  constructor(public payload: ManagerCompanyUser) {}
}
export class IsManagerCompanyUserLockedForUpdateSuccess implements Action {
  readonly type = ManagerCompaniesActionTypes.IsManagerCompanyUserLockedForUpdateSuccess;
  constructor(public payload: ManagerJobLockStatus) {}
}
export class IsManagerCompanyUserLockedForUpdateFail implements Action {
  readonly type = ManagerCompaniesActionTypes.IsManagerCompanyUserLockedForUpdateFail;
  constructor(public payload: any) {}
}

export class ManagerCompanyUsersLockedForUpdateLoadData implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyUsersLockedForUpdateLoadData;
  constructor(public payload: number) {}
}
export class ManagerCompanyUsersLockedForUpdateLoadSuccess implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyUsersLockedForUpdateLoadSuccess;
  constructor(public payload: ManagerJobLockStatus[]) {}
}
export class ManagerCompanyUsersLockedForUpdateLoadFail implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyUsersLockedForUpdateLoadFail;
  constructor(public payload: any) {}
}
export class ClearManagerCompanyUsersLockedForUpdateState implements Action {
  readonly type = ManagerCompaniesActionTypes.ClearManagerCompanyUsersLockedForUpdateState;
  constructor() {}
}


export class ManagerUserLockUpdate implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerUserLockUpdate;
  constructor(public payload: ManagerJobLockStatus[]) {}
}

export class SetCustomerSelection implements Action {
  readonly type = ManagerCompaniesActionTypes.SetCustomerSelection;
  constructor(public payload: string[]) {}
}
export class SetPrimaryContact implements Action {
  readonly type = ManagerCompaniesActionTypes.SetPrimaryContact;
  constructor(public payload: ManagerCompanyUser) {}
}
export class SetPrimaryContactSuccess implements Action {
  readonly type = ManagerCompaniesActionTypes.SetPrimaryContactSuccess;
  constructor(public payload: ManagerCompanyUser) {}
}
export class SetPrimaryContactFail implements Action {
  readonly type = ManagerCompaniesActionTypes.SetPrimaryContactFail;
  constructor(public payload: any) {}
}
export class ManagerCompanyTabChanged implements Action {
  readonly type = ManagerCompaniesActionTypes.ManagerCompanyTabChanged;
  constructor(public payload: number) {}
}
export class LockManagerCompanyUserForDelete implements Action {
  readonly type = ManagerCompaniesActionTypes.LockManagerCompanyUserForDelete;
  constructor(public payload: ManagerCompanyUser) {}
}
export class LockManagerCompanyUserForDeleteSuccess implements Action {
  readonly type = ManagerCompaniesActionTypes.LockManagerCompanyUserForDeleteSuccess;
  constructor(public payload: ManagerJobLockStatus) {}
}
export class LockManagerCompanyUserForDeleteFail implements Action {
  readonly type = ManagerCompaniesActionTypes.LockManagerCompanyUserForDeleteFail;
  constructor(public payload: any) {}
}
export class ClearLockManagerCompanyUserForDeleteState implements Action {
  readonly type = ManagerCompaniesActionTypes.ClearLockManagerCompanyUserForDeleteState;
  constructor() {}
}


export type ManagerCompaniesActions =
  | ManagerCompaniesLoadData
  | ManagerCompaniesLoadSuccess
  | ManagerCompaniesLoadFail
  | ManagerCompanySelect
  | ManagerCompaniesUsersLoadData
  | ManagerCompaniesUsersLoadSuccess
  | ManagerCompaniesUsersLoadFail
  | ManagerCompanyUserSelect
  | UpdateManagerCompanyUser
  | UpdateManagerCompanyUserSuccess
  | UpdateManagerCompanyUserFail
  | ManagerCompanyRemove
  | ManagerCompanyRemoveSuccess
  | ManagerCompanyRemoveFail
  | ManagerCompanyCustomersLoadData
  | ManagerCompanyCustomersLoadSuccess
  | ManagerCompanyCustomersLoadFail
  | ManagerCompanyUserCustomersLoadData
  | ManagerCompanyUserCustomersLoadSuccess
  | ManagerCompanyUserCustomersLoadFail
  | IsManagerCompanyUserExclusiveAdministrator
  | IsManagerCompanyUserExclusiveAdministratorSuccess
  | IsManagerCompanyUserExclusiveAdministratorFail
  | IsManagerCompanyUserLockedForUpdate
  | IsManagerCompanyUserLockedForUpdateSuccess
  | IsManagerCompanyUserLockedForUpdateFail
  | BulkUpdateManagerCompanyUser
  | BulkUpdateManagerCompanyUserSuccess
  | BulkUpdateManagerCompanyUserFail
  | ClearBulkUpdateManagerCompanyUserState
  | ManagerCompanyUsersLockedForUpdateLoadData
  | ManagerCompanyUsersLockedForUpdateLoadSuccess
  | ManagerCompanyUsersLockedForUpdateLoadFail
  | ClearManagerCompanyUsersLockedForUpdateState
  | SetCustomerSelection
  | SetPrimaryContact
  | SetPrimaryContactSuccess
  | SetPrimaryContactFail
  | ManagerCompanyTabChanged
  | ManagerUserLockUpdate
  | LockManagerCompanyUserForDelete
  | LockManagerCompanyUserForDeleteSuccess
  | LockManagerCompanyUserForDeleteFail
  | ClearLockManagerCompanyUserForDeleteState;
